// Mock data for the component gallery (Step 3). No real data/business logic.
export const mockUsers = [
  { id: "u1", name: "Anna Lind", role: "personal", title: "Servitris" },
  { id: "u2", name: "Marcus Holm", role: "skiftledare", title: "Skiftledare" },
  { id: "u3", name: "Sara Berg", role: "chef", title: "Restaurangchef" },
];

export const mockTasks = [
  { id: "t1", entity_type: "task", title: "Byt frityrolja", status: "todo", priority: "high",
    assignee: mockUsers[0], due_at: "2026-06-28T16:00:00Z", tags: ["kök", "säkerhet"], updated_at: "2026-06-27T10:00:00Z" },
  { id: "t2", entity_type: "task", title: "Räkna växelkassa", status: "in_progress", priority: "medium",
    assignee: mockUsers[1], due_at: "2026-06-27T22:00:00Z", tags: ["kassa"], updated_at: "2026-06-27T12:30:00Z" },
  { id: "t3", entity_type: "task", title: "Kalibrera kyltermometer", status: "done", priority: "low",
    assignee: mockUsers[2], due_at: null, tags: ["haccp"], updated_at: "2026-06-26T09:00:00Z" },
];

export const mockManual = { id: "m1", entity_type: "manual", title: "Öppningsrutin kök", category: "Rutin",
  status: "published", author: "Sara Berg", tags: ["öppning"], updated_at: "2026-06-20T08:00:00Z",
  content: "1. Sätt på utrustning.\n2. Kontrollera temperaturer.\n3. Mise en place." };

export const mockIncident = { id: "i1", entity_type: "incident", title: "Kombiugn håller inte temperatur",
  severity: "high", status: "open", reporter: "Marcus Holm", tags: ["utrustning"],
  description: "Ugn 2 når inte 200°C.", updated_at: "2026-06-27T11:00:00Z" };

export const mockChecklist = {
  id: "c1", entity_type: "checklist", title: "Öppning kök", frequency: "Dagligen", status: "published",
  items: [
    { id: "ci1", text: "Kontrollera kyltemperaturer", checked: true, requires_photo: true },
    { id: "ci2", text: "Starta utrustning", checked: true },
    { id: "ci3", text: "Mise en place klar", checked: false },
    { id: "ci4", text: "Kvittera leveranser", checked: false },
  ],
};

export const mockComments = [
  { id: "cm1", author: "Marcus Holm", body: "Beställt reservdel, kommer imorgon.", created_at: "2026-06-27T11:20:00Z" },
  { id: "cm2", author: "Sara Berg", body: "Tack! Markera som åtgärdad när klart.", created_at: "2026-06-27T11:35:00Z" },
];

export const mockAttachments = [
  { id: "a1", file_name: "ugn.jpg", mime_type: "image/jpeg", ai_tags: ["ugn", "felkod"], url: "" },
  { id: "a2", file_name: "kvitto.pdf", mime_type: "application/pdf", url: "" },
];

export const mockAudit = [
  { id: "h1", action: "create", actor_name: "Marcus Holm", entity_type: "incident", created_at: "2026-06-27T11:00:00Z" },
  { id: "h2", action: "update", actor_name: "Sara Berg", entity_type: "incident", created_at: "2026-06-27T11:35:00Z",
    diff: { status: { from: "open", to: "investigating" } } },
  { id: "h3", action: "ai_analyze", actor_name: "System", entity_type: "incident", created_at: "2026-06-27T11:36:00Z" },
];

export const mockAI = {
  id: "ai1", model: "anthropic/claude-sonnet-4-6", prompt_version: "1.0.0", confidence: 0.86,
  mode: "auto", created_at: "2026-06-27T11:36:00Z",
  result: { analysis: "Ugnen tappar temperatur troligen pga defekt termostat. Risk för matsäkerhet vid lunch.",
    risk: "hög", recommended_actions: ["Ta ugn 2 ur drift", "Boka servicetekniker", "Flytta lunchprep till ugn 1"] },
};

export const mockNotifications = [
  { id: "n1", title: "Nytt problem rapporterat", body: "Marcus Holm · Kök", created_at: "2026-06-27T11:00:00Z", read: false },
  { id: "n2", title: "Uppgift tilldelad", body: "Byt frityrolja", created_at: "2026-06-27T10:00:00Z", read: false },
  { id: "n3", title: "Checklista slutförd", body: "Öppning kök", created_at: "2026-06-27T08:30:00Z", read: true },
];

export const mockKpis = [
  { label: "Öppna problem", value: 3, delta: -1, tone: "danger" },
  { label: "Klart idag", value: "82%", delta: 6, tone: "success" },
  { label: "Uppgifter", value: 12, delta: 2 },
  { label: "Manualer", value: 24 },
];

export const mockNav = [
  { key: "kok", label: "Kök", icon: "ChefHat", badge: 2 },
  { key: "servering", label: "Servering", icon: "UtensilsCrossed" },
  { key: "disk", label: "Disk & Städ", icon: "Sparkles" },
  { key: "kassa", label: "Kassa", icon: "Wallet" },
  { key: "lager", label: "Lager", icon: "Package" },
];

export const mockSearchGroups = {
  task: [{ ref_id: "t1", title: "Byt frityrolja", status: "todo" }],
  manual: [{ ref_id: "m1", title: "Öppningsrutin kök", status: "published" }],
  incident: [{ ref_id: "i1", title: "Kombiugn håller inte temperatur", status: "open" }],
};
